module.exports = __webpack_public_path__ + "img/tjfoot8.16a8490c.jpg";